import {stringFormat} from '@ey/utils';
import {labels} from '../../../../../util/utils';

export default (orgStructure) => {
	let newOrg = _.cloneDeep(orgStructure);
                newOrg.map((o) => {
		(o.pid = o.parentId),
			(o.engagementLabel = labels.connectedToEngagements(o.engagements.length)),
			(o.accessGroupLabel = labels.connectedToAccessGroups(o.accessGroups.length));
		o.tags = setTagsForNodes(o.level);
	});
	newOrg = _.map(
		newOrg,
		({
			pid,
			engagementLabel,
			accessGroupLabel,
			id,
			engagements,
			contacts,
			accessGroups,
			entityName,
			entityAdmins,
			domains,
			tags
		}) => {
			let admins = _.sortBy(_.uniqBy(entityAdmins, 'userId'), 'firstName');
			let firstAdmin =
			admins.length > 0
							? `${admins[0].firstName} ${admins[0].lastName ? admins[0].lastName : ''}`
							: labels.adminsNoneLabel;
			let adminsHeaderLabel = labels.adminsHeaderLabel;
			let adminsMoreCountLabel = '';
			let domainsMoreCountLabel = '';
			if (admins.length > 1) {
				adminsMoreCountLabel = stringFormat(labels.moreCountLabel, admins.length - 1);
			}
			let firstDomain = domains?.length > 0 ? domains[0] : labels.none;
			let domainsHeaderLabel = labels.domainsHeaderLabel;
			if (domains?.length > 1) {
				domainsMoreCountLabel = stringFormat(labels.moreCountLabel, domains.length - 1);
			}
			return {
				pid,
				engagementLabel,
				accessGroupLabel,
				id,
				engagements,
				contacts,
				accessGroups,
				entityName,
				admins,
				domains,
				tags,
				adminsHeaderLabel,
				firstAdmin,
				domainsHeaderLabel,
				firstDomain,
				adminsMoreCountLabel,
				domainsMoreCountLabel
			};
		}
	);
	return newOrg;
};
const setTagsForNodes = (level) => {
	// if (level == 1) {
	// 	return ['rootElement_maxNodeAddedAtNextLevel'];
	// }

	if (level == 2 || level == 3) {
		return ['middleNodeElements'];
	}

	if (level == 4) {
		return ['lastNodeElements'];
	}
};